<template>
  <span class="new-live-chat">
    <div class="align-center">
      <div class="d-flex justify-space-between mb-2">
        <div class="d-flex align-center">
          <label class="page_title mr-3">Chat</label>
          <v-skeleton-loader
            v-if="isSwitchLoading"
            class="ml-auto"
            style="border-radius: none"
            type="image"
            width="34px"
            height="34px"
          ></v-skeleton-loader>
          <v-switch
            v-else
            :disabled="isMessagesLoading"
            v-model="chatSwitch"
            class="pa-0 ma-0"
            hide-details
            :label="
              chatSwitch
                ? $t('message.pages.live.active')
                : $t('message.pages.live.disabled')
            "
          />
        </div>
        <div class="mb-2" style="position: relative">
          <div
            v-if="isModalVisible"
            class="modal d-block"
            ref="modalBox"
            @click.stop
          >
            <div style="display: grid">
              <div class="d-flex">
                <label class="modal_title mb-5">{{
                  $t('message.pages.live.chat.embedChat')
                }}</label>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                      <v-icon
                        style="color: var(--v-neutral-lighten1)"
                        size="18"
                      >
                        mdi-help-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-container
                    class="text-body-2 pa-0"
                    style="max-width: 250px"
                    v-html="$t('message.pages.live.embedChatDescription')"
                  ></v-container>
                </v-tooltip>
              </div>
              <span style="font-size: 12px; font-weight: 500">{{
                $t('message.pages.live.chat.embedCode')
              }}</span>
            </div>
            <v-textarea-legacy
              height="88px"
              v-if="embedSize.selected === 'responsive'"
              readonly
              v-model="chatLinkResp"
              outlined
              no-resize
              class="wrapText embedInput"
              dense
              color="primary"
              style="font-size: 14px"
            >
            </v-textarea-legacy>
            <v-textarea-legacy
              v-else
              height="88px"
              v-model="chatLink"
              outlined
              color="red"
              readonly
              no-resize
              dense
              style="font-size: 14px"
            >
            </v-textarea-legacy>
            <div class="d-flex align-center">
              <span style="font-weight: 500; line-height: 16px">
                {{ $t('message.pages.live.chat.size') }}
              </span>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                    <v-icon style="color: var(--v-neutral-lighten1)" size="18">
                      mdi-help-circle
                    </v-icon>
                  </v-btn>
                </template>
                <v-container
                  class="text-body-2 pa-0"
                  style="max-width: 250px"
                  v-html="$t('message.pages.live.sizeDescription')"
                ></v-container>
              </v-tooltip>
            </div>
            <span style="background-color: red">
              <div
                class="d-flex align-end justify-space-between"
                style="width: 100%"
              >
                <div class="select-size d-flex">
                  <v-radio-group
                    v-model="embedSize.selected"
                    class="my-4"
                    row
                    hide-details
                  >
                    <v-radio
                      v-for="item in embedSize.items"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </v-radio-group>
                </div>
                <div
                  v-if="embedSize.selected === 'fixed'"
                  class="d-flex size-fields"
                >
                  <span>
                    <span class="label_title" style="font: 14px">
                      {{
                        $t(
                          'message.pages.videoEditModal.embedConfiguration.width'
                        )
                      }}
                      (px)
                    </span>
                    <v-text-field
                      type="number"
                      color="primary"
                      style="max-width: 90px"
                      v-model="embedChat.width"
                      placeholder="720px"
                      outlined
                      dense
                      hide-details
                    />
                  </span>
                  <span class="ml-3">
                    <span class="label_title" style="font: 14px">
                      {{
                        $t(
                          'message.pages.videoEditModal.embedConfiguration.height'
                        )
                      }}
                      (px)
                    </span>
                    <v-text-field
                      type="number"
                      style="max-width: 90px"
                      color="primary"
                      v-model="embedChat.height"
                      placeholder="360px"
                      outlined
                      dense
                      hide-details
                    />
                  </span>
                </div>
              </div>
            </span>
          </div>
          <div v-if="chat_id === ''">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="{ ...on, click: toggleModal }">
                  <v-btn :disabled="chat_id === ''" color="primary" outlined>
                    {{ $t('message.pages.live.chat.chatLink') }}
                  </v-btn>
                </div>
              </template>
              {{ $t('message.pages.live.chat.waitingMessage') }}
            </v-tooltip>
          </div>

          <div v-else v-bind="attrs" v-on="{ ...on, click: toggleModal }">
            <v-btn :disabled="chat_id === ''" color="primary" outlined>
              {{ $t('message.pages.live.chat.chatLink') }}
            </v-btn>
          </div>
        </div>
      </div>

      <div class="d-flex options" :class="{ disabled: !chatSwitch }">
        <div
          :class="{ selected: form.selectedOption === 'Conversa' }"
          class="chatOptions_selector"
        >
          <span
            :class="{ selected: form.selectedOption === 'Conversa' }"
            @click="selectOption('Conversa')"
          >
            {{ $t('message.pages.live.chat.chatOptions') }}
          </span>
        </div>
        <div
          :class="{ selected: form.selectedOption === 'Usuários' }"
          class="chatOptions_selector"
        >
          <span
            :class="{ selected: form.selectedOption === 'Usuários' }"
            @click="selectOption('Usuários')"
          >
            {{ $t('message.pages.live.chat.userOption') }}
          </span>
        </div>
      </div>
    </div>

    <div class="chat-container">
      <div class="chat__content">
        <div class="waiting-container" v-if="!chatSwitch">
          <img
            class="pb-4"
            src="@/assets/waitingLive.svg"
            alt="Waiting for transmission"
          />
          <span class="waiting-message">
            {{ $t('message.pages.live.chat.waitingMessage') }}
          </span>
        </div>

        <div :key="componentKey">
          <div
            v-if="
              form.selectedOption === 'Conversa' &&
              chatSwitch &&
              isMessagesLoading
            "
            style="overflow: hidden"
          >
            <v-row no-gutters>
              <loading-logo :value="200" style="height: 50vh" />
            </v-row>
          </div>

          <div
            v-if="
              form.selectedOption === 'Conversa' &&
              chatSwitch &&
              !isMessagesLoading
            "
            class="chat-box"
            id="chat-box"
          >
            <virtual-list
              class="scroll-chat-box"
              ref="chatBox"
              :style="{ height: virtualListHeight + 'px', overflowY: 'auto' }"
              :data-key="'message_id'"
              :data-sources="messages"
              :data-component="item"
            />
          </div>
        </div>

        <div v-if="form.selectedOption === 'Usuários' && chatSwitch">
          <template>
            <v-text-field
              v-model="searchText"
              :placeholder="'Buscar pessoa'"
              class="mb-7 mt-6"
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </template>

          <div v-if="isLoading">
            <v-skeleton-loader
              v-for="(item, index) in 7"
              :key="index"
              type="image"
              height="55px"
              style="
                margin-top: 4px;
                margin-bottom: 4px;
                padding-left: 10px;
                padding-right: 10px;
                border-radius: 10px;
              "
            ></v-skeleton-loader>
          </div>

          <div v-if="!isLoading">
            <div
              v-for="user in filteredUsers"
              :key="user._id"
              class="user-item d-flex pb-2 pt-2"
              style="
                max-width: 99%;
                display: flex;
                align-items: center;
                border-radius: 4px;
              "
              @mouseover="user.hover = true"
              @mouseleave="user.hover = false"
            >
              <div
                v-if="user.name_occurence > 1"
                style="white-space: nowrap"
                class="d-flex"
              >
                <span class="userInitials mt-1">
                  {{ generateInitials(user.user_name) }}</span
                >
                <div style="padding-left: 5px">
                  <span
                    :class="{ 'admin-name': user.is_admin }"
                    class="users-name"
                    >{{ user.user_name }} ({{ user.name_occurence }}) </span
                  ><span
                    style="
                      font-weight: 400px;
                      font-size: 14px;
                      line-height: 21px;
                    "
                    >IP {{ user.user_ip_address }}
                  </span>
                </div>
              </div>
              <div v-else style="white-space: nowrap" class="d-flex">
                <span class="userInitials">
                  {{ generateInitials(user.user_name) }}
                </span>
                <div style="padding-left: 5px">
                  <span
                    :class="{ 'admin-name': user.is_admin }"
                    class="users-name"
                    >{{ user.user_name }}
                  </span>
                  <span
                    style="
                      font-weight: 400px;
                      font-size: 14px;
                      line-height: 21px;
                    "
                    >IP {{ user.user_ip_address }}
                  </span>
                </div>
              </div>

              <v-menu v-model="user.menuOpen" offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon v-if="!user.is_admin" class="dots-icon" v-on="on"
                    >mdi-dots-vertical</v-icon
                  >
                </template>
                <v-list>
                  <v-list-item @click="removeUserFromChat(user)">
                    <v-list-item-title style="font-size: 14px; color: red">{{
                      $t('message.pages.live.chat.blockUser')
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <template v-if="filteredBlockedUsers.length > 0">
            <span class="blocked-users mt-5 mb-4">
              {{ $t('message.pages.live.chat.blockedUsers') }}
            </span>
            <div
              v-for="user in filteredBlockedUsers"
              :key="user._id"
              class="user-item d-flex pb-2 pt-2"
              style="
                max-width: 99%;
                display: flex;
                align-items: center;
                border-radius: 4px;
                opacity: 0.5;
              "
              @mouseover="user.hover = true"
              @mouseleave="user.hover = false"
            >
              <div
                v-if="user.name_occurence > 1"
                style="white-space: nowrap"
                class="d-flex"
              >
                <span class="userInitials mt-1">
                  {{ generateInitials(user.user_name) }}</span
                >
                <div style="padding-left: 5px">
                  <span class="users-name"
                    >{{ user.user_name }} ({{ user.name_occurence }}) </span
                  ><span
                    style="
                      font-weight: 400px;
                      font-size: 14px;
                      line-height: 21px;
                    "
                    >IP {{ user.user_ip_address }}
                  </span>
                </div>
              </div>
              <div v-else style="white-space: nowrap" class="d-flex">
                <span class="userInitials">
                  {{ generateInitials(user.user_name) }}
                </span>
                <div style="padding-left: 5px">
                  <span class="users-name">{{ user.user_name }}</span>
                  <span
                    style="
                      font-weight: 400px;
                      font-size: 14px;
                      line-height: 21px;
                    "
                    >IP {{ user.user_ip_address }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div
      v-if="form.selectedOption === 'Conversa'"
      class="chat__message"
      :class="{ disabled: !chatSwitch || isMessagesLoading }"
    >
      <div class="chat-content d-flex">
        <div
          ref="messageInput"
          :contenteditable="!isMessagesLoading"
          class="editable-content"
          :class="{ 'limit-exceeded': isLimitExceeded }"
          @input="handleInput"
          @keypress="handleKeyPress($event)"
          :placeholder="$i18next.t('message.pages.live.chat.writeMessage')"
          :style="{ minHeight: '40px', padding: '8px' }"
        >
          <span class="over-texting" ref="overTexting"> </span>
          <span v-show="!inputMessage" class="placeholder">
            {{ $t('message.pages.live.chat.writeMessage') }}
          </span>
        </div>

        <div
          style="
            display: grid;
            justify-content: space-between;
            justify-items: center;
            align-items: flex-end;
          "
        >
          <div
            v-if="exceededCount > 0 && inputMessage.length === 250"
            align="center"
            class="exceededCount pt-2"
          >
            <span> -{{ exceededCount }}</span>
          </div>
          <div class="icons-container">
            <emoji-picker @emoji="append" :search="search">
              <button
                :disabled="inputMessage.length === 250"
                class="emoji-invoker"
                slot="emoji-invoker"
                @click="clearTextField()"
                slot-scope="{ events: { click: clickEvent } }"
                @click.stop="clickEvent"
              >
                <v-icon style="color: var(--v-neutral-lighten1)">
                  mdi-emoticon-outline</v-icon
                >
              </button>
              <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                <div class="emoji-picker">
                  <div class="emoji-picker__search">
                    <input class="mb-3" type="text" v-model="search" v-focus />
                  </div>
                  <div>
                    <div
                      v-for="(emojiGroup, category) in emojis"
                      :key="category"
                    >
                      <h5 class="mb-2 mt-2">{{ category }}</h5>
                      <div class="emojis">
                        <span
                          v-for="(emoji, emojiName) in emojiGroup"
                          :key="emojiName"
                          @click="insert(emoji)"
                          :title="emojiName"
                          >{{ emoji }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </emoji-picker>
            <img
              v-if="inputMessage.length === 250 && exceededCount > 0"
              style="padding-bottom: 2px"
              class="send-icon"
              src="@/assets/sendButton-disabled.svg"
              max-width="180"
            />
            <img
              v-else
              @click="sendMessage"
              style="padding-bottom: 2px"
              class="send-icon"
              src="@/assets/sendButton.svg"
              max-width="180"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker'
import Vue from 'vue'
import io from 'socket.io-client'
import i18n from '@/translations/lang'
import { LIVE_CHAT } from '@/config/envs'
import planApi from '@/services/planApi'
import LoadingLogo from '@/components/LoadingLogo.vue'
import liveService from '@/services/liveServiceV2'
import liveChat from '@/services/liveChat'
import { VMenu, VList, VListItem, VListItemTitle } from 'vuetify/lib'
import VirtualList from 'vue-virtual-scroll-list'
import Item from './Item'

Vue.use(EmojiPicker)

export default {
  name: 'NewLiveV2Chat',
  props: {
    video: {
      type: Object,
    },
  },
  components: {
    EmojiPicker,
    VMenu,
    LoadingLogo,
    VList,
    VListItem,
    VListItemTitle,
    VirtualList,
  },
  data: () => ({
    form: {
      selectedOption: 'Conversa',
      disabled: true,
    },
    input: '',
    search: '',
    item: Item,
    virtualListHeight: 0,
    isLimitExceeded: false,
    textareaHeight: '40px',
    selectedUser: null,
    teste: false,
    embedChat: {
      width: 360,
      height: 720,
    },
    chatStatus: '',
    searchText: '',
    embedSize: {
      items: [
        {
          text: i18n.t('message.pages.live.chat.responsive'),
          value: 'responsive',
        },
        {
          text: i18n.t('message.pages.live.chat.fixed'),
          value: 'fixed',
        },
      ],
      selected: 'fixed',
    },
    chatSwitch: false,
    attrs: {},
    on: {},
    chatLinkResp: '',
    componentKey: 0,
    isCopied: false,
    livePlayer: '',
    adminId: '',
    sizeSwitch: false,
    isModalVisible: false,
    isChatCreated: false,
    isLoading: true,
    isSwitchLoading: true,
    isMessagesLoading: false,
    scrollHeight: 0,
    userInitials: '',
    subscriptionName: 'teste123',
    isAdmin: false,
    messageId: '',
    userName: '',
    listUserName: '',
    messages: [],
    listedUsers: [],
    users: [],
    inputMessage: '',
    exceededCount: 0,
    socket: null,
    chat_id: '',
    user_id: '',
  }),
  computed: {
    chatLink() {
      const base_url = this.livePlayer.split('?')[0]
      let chatLink = `<iframe src="${base_url}live_chat.html?c=${this.chat_id}" style="border:none;position:absolute;top:0;left:0;" width="${this.embedChat.width}" height="${this.embedChat.height}" fetchpriority="high"></iframe>`
      return chatLink
    },
    liveId() {
      return this.$route.params.id
    },
    filteredUsers() {
      return this.listedUsers.filter(
        (user) =>
          user.user_name
            .toLowerCase()
            .includes(this.searchText.toLowerCase()) && user.is_valid !== false
      )
    },
    filteredBlockedUsers() {
      return this.listedUsers.filter(
        (user) =>
          user.user_name
            .toLowerCase()
            .includes(this.searchText.toLowerCase()) && user.is_valid === false
      )
    },
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('resize', this.calculateVirtualListHeight)
    if (this.socket) {
      this.socket.off('message')
      this.socket.off('user_joined')
      this.socket.off('user_left')
      this.socket.off('error_event')
      this.socket.disconnect()
    }
  },
  async mounted() {
    this.$root.$on('removeUserFromChatMessage', (data) => {
      this.removeUserFromChatMessage(data)
    })
    this.$root.$on('selectUser', (data) => {
      this.selectUser(data)
    })
    this.$root.$on('removeMessage', (data) => {
      this.removeMessage(data)
    })
    this.chatSwitch = false
    await this.checkSwitch()
    this.calculateVirtualListHeight()
    window.addEventListener('resize', this.calculateVirtualListHeight)

    let socket_url = LIVE_CHAT
    this.socket = io(socket_url)

    this.socket.on('user_left', (data) => {
      this.messages.push({ user_name: '', text: data.message })
    })

    this.scrollToBottom()

    this.socket.on('error_event', (data) => {
      console.error(data.message)
    })
  },

  watch: {
    chatSwitch: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal === true) {
            this.isMessagesLoading = true
            await this.getLiveInfo()
            this.listChatUsers()
            this.getchatLink()
            this.setupConnection()
          }
          if (newVal === false) {
            this.socket.disconnect()
            this.socket.on('disconnect', () => {})
          }
          if (this.chat_id === null) {
            await this.createChat()
            this.registerUser()
            await this.getLiveInfo()
            this.getchatLink()
            this.changeChatStatus()
            this.setupConnection()
          }
          await this.getLiveInfo()
          this.changeChatStatus()
        }
      },
    },
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollChatBox =
          document.getElementsByClassName('scroll-chat-box')[0]
        if (scrollChatBox) {
          scrollChatBox.scrollTop = scrollChatBox.scrollHeight
        }
      })
    },

    calculateVirtualListHeight() {
      const chatContainer = document.getElementsByClassName('chat-container')[0]
      if (chatContainer) {
        const containerHeight = chatContainer.clientHeight
        this.virtualListHeight = containerHeight
      }
    },

    handleKeyPress(event) {
      if (event.key === 'Enter') {
        if (this.inputMessage.length === 250 && this.exceededCount > 0) {
          event.preventDefault()
        } else {
          event.preventDefault()
          this.sendMessage()
        }
      }
    },

    handleInput(event) {
      const fullText = event.target.innerText
      if (fullText.length >= 250) {
        const withinLimitText = fullText.substring(0, 250)
        const overLimitText = fullText.substring(250)

        this.inputMessage = withinLimitText
        this.exceededCount = fullText.length - 250
        event.target.innerHTML = `${withinLimitText}<span class="over-texting">${overLimitText}</span>`

        const range = document.createRange()
        const sel = window.getSelection()
        range.selectNodeContents(event.target)
        range.collapse(false)
        sel.removeAllRanges()
        sel.addRange(range)
      } else {
        this.inputMessage = fullText
      }
    },
    appendEmoji(emoji) {
      const messageInput = this.$refs.messageInput
      messageInput.innerText += emoji
      this.inputMessage += emoji
      messageInput.focus()
    },

    clearTextField() {
      const messageInput = this.$refs.messageInput
      if (this.inputMessage.length === 0) {
        messageInput.innerText = ''
        this.inputMessage = ''
      }
    },
    getchatLink() {
      const base_url = this.livePlayer.split('?')[0]
      this.chatLinkResp = `<div style="position:relative;width:100%;height:100%;padding-top:56.25%"><iframe src="${base_url}live_chat.html?c=${this.chat_id}" style="border:none;position:absolute;top:0;left:0;" width="100%" height="100%" fetchpriority="high"></iframe><div>`
    },

    toggleModal(event) {
      event.stopPropagation()
      this.isModalVisible = !this.isModalVisible
      if (this.isModalVisible) {
        this.$nextTick(() => {
          window.addEventListener('click', this.handleOutsideClick, true)
        })
      } else {
        window.removeEventListener('click', this.handleOutsideClick, true)
      }
    },

    handleOutsideClick(event) {
      if (this.$refs.modalBox && !this.$refs.modalBox.contains(event.target)) {
        this.isModalVisible = false
        window.removeEventListener('click', this.handleOutsideClick, true)
      }
    },

    setupConnection() {
      let socket_url = LIVE_CHAT
      this.socket = io(socket_url)

      this.socket.on('connect', () => {
        this.socket.emit('join_room', {
          chat_id: this.chat_id,
          user_id: this.user_id,
        })
      })

      this.socket.on('user_joined', async (data) => {
        try {
          const tempId = Date.now()
          const response = await liveChat.getChatUsers(this.chat_id)
          const chatUsers = response.users

          const user = chatUsers.find((user) => user._id === data.user_id)

          if (user) {
            const newMessage = {
              user_name: '',
              text: `${user.user_name} entrou na sala`,
              message_id: tempId,
              sent_at: '',
              is_admin: false,
            }
            this.listChatUsers()
            this.messages.push(newMessage)
            this.scrollToBottom()
          } else {
            console.error(`Usuário com ID ${data.user_id} não encontrado`)
          }
        } catch (error) {
          console.error('Error getting chat users:', error)
        }
      })

      this.socket.on('message', (data) => {
        this.isAdmin = data.is_admin
        const newMessage = {
          user_name: data.user_name,
          text: data.message,
          message_id: data.message_id,
          sent_at: data.sent_at,
          is_admin: data.is_admin,
        }
        const date = new Date(data.sent_at)
        const hours =
          date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        const minutes =
          date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        newMessage.sent_at = hours + ':' + minutes
        this.sentAt = newMessage.sent_at
        if (
          data.user_name !== this.subscriptionName &&
          data.is_admin === false
        ) {
          this.messages.push(newMessage)
          this.scrollToBottom()
        }
      })
    },

    formatSentAt(sentAt) {
      const date = new Date(sentAt)
      const hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      const minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      return hours + ':' + minutes
    },

    async checkSwitch() {
      try {
        const response = await liveService.getLive(this.$route.params.id)
        this.chatStatus = response.data.chat_status

        if (response.data.chat_status === 'active') {
          this.chatSwitch = true
        } else {
          this.chatSwitch = false
        }
      } finally {
        this.isSwitchLoading = false
      }
    },

    async loadChatMessages(sortBy = 'sent_at', sortOrder = 'asc') {
      const response = await liveChat.getChatMessages(
        this.chat_id,
        undefined,
        undefined,
        sortBy,
        sortOrder
      )
      const validMessages = response.messages.filter(
        (message) => message.is_valid
      )
      try {
        this.messages = await Promise.all(
          validMessages.map(async (message) => ({
            user_name: (await this.getName(message.user_id)) + '',
            text: message.message,
            message_id: message._id,
            sent_at: this.formatSentAt(message.sent_at),
            is_admin: await this.isRootAdmin(message.user_id),
            isSentByUser: true,
          }))
        )
        const tempId = Date.now()
        const newMessage = {
          user_name: '',
          text: this.$t('message.pages.live.chat.lastMessages'),
          sent_at: '',
          message_id: tempId,
          is_admin: false,
        }
        if (validMessages.length > 0) {
          this.messages.push(newMessage)
        }
      } catch (error) {
        console.error('Error loading chat messages:', error)
      } finally {
        this.scrollToBottom()
        this.isMessagesLoading = false
      }
    },

    async getName(id) {
      const response = this.listedUsers

      const user = response.find((user) => user._id === id)
      let username = user.user_name
      if (username === this.subscriptionName) {
        username = this.$t('message.pages.live.chat.you')
      }
      return username
    },

    async isRootAdmin(id) {
      const response = this.listedUsers
      let isAdmin = false
      const user = response.find((user) => user._id === id)
      let username = user.user_name
      if (username === this.subscriptionName) {
        isAdmin = false
        return false
      } else {
        isAdmin = user.is_admin
        return isAdmin
      }
    },

    async createChat() {
      const response = await liveChat.createChat(this.liveId)
      this.chat_id = response.chat_id
      this.getchatLink()
    },

    async changeChatStatus() {
      if (this.chatStatus === 'active' || this.chatStatus === 'inactive') {
        await liveChat.changeChatStatus(this.chat_id, 'active')
        this.chatStatus = 'active'
        this.listChatUsers()
        this.loadChatMessages()
      } else {
        await liveChat.changeChatStatus(this.chat_id, 'inactive')
      }
    },

    async loadPlanData() {
      try {
        const { data } = await planApi.getSubscription()
        this.listUserName = data.name

        const words = data.name.split(' ')

        if (words[0].length < 3 && words.length > 1) {
          this.subscriptionName = words[0] + ' ' + words[1]
        } else {
          this.subscriptionName = words[0]
        }

        this.userName = this.subscriptionName.replace(/[^a-zA-Z0-9 ]/g, '')

        if (this.userName.replace(/\s/g, '').length < 3) {
          this.userName = this.userName.padEnd(3, ' ')
        }
      } catch (e) {
        this.error = true
      }
    },
    async removeMessage(messageData) {
      const message = messageData
      if (message.message_id) {
        try {
          await liveChat.removeMessageFromChat(this.chat_id, message.message_id)
          this.messages = this.messages.filter(
            (msg) => msg.message_id !== message.message_id
          )
        } catch (error) {
          console.error('Error removing message:', error)
        }
      } else {
        const messageText = message.text
        const response = await liveChat.getChatMessages(this.chat_id)
        const sameText = response.messages.filter(
          (message) => message.message === messageText && message.is_valid
        )
        await liveChat.removeMessageFromChat(this.chat_id, sameText[0]._id)
        this.messages = this.messages.filter(
          (msg) => msg.message_id !== message.message_id
        )
      }
    },
    generateInitials(name) {
      const nameParts = name.split(' ')
      return nameParts
        .filter((part) => part)
        .map((part) => part[0].toUpperCase())
        .join('')
    },

    async getChatUsers() {
      const response = await liveChat.getChatUsers(this.chat_id)

      this.users = response.users
    },

    async listChatUsers() {
      this.isLoading = true
      const response = await liveChat.getChatUsers(this.chat_id)
      this.listedUsers = response.users
      this.isLoading = false
    },

    async getInvalidUsers() {
      const response = await liveChat.getChatUsers(this.chat_id)
      this.users = response.users
        .filter((user) => user.is_valid === false)
        .map((user) => ({ ...user, hover: false, menuOpen: false }))
    },

    selectUser(user) {
      console.log(user)
      this.selectedUser = user
    },

    async removeUserFromChat(user) {
      try {
        await liveChat.removeUserFromChat(this.chat_id, user._id)
        const userIndex = this.users.findIndex((u) => u._id === user._id)
        if (userIndex !== -1) {
          this.users.splice(userIndex, 1)
          this.listChatUsers()
        }
        for (let i = this.messages.length - 1; i >= 0; i--) {
          if (this.messages[i].user_id === user._id) {
            await this.removeMessage(i)
          }
        }
      } catch (error) {
        console.error('Error removing user from chat:', error)
      }
    },

    async removeUserFromChatMessage(user) {
      const response = await liveChat.getChatMessages(this.chat_id)

      let userId = null
      response.messages.forEach((message) => {
        if (message._id === user.message_id) {
          userId = message.user_id
        }
      })
      try {
        await liveChat.removeUserFromChat(this.chat_id, userId)
        const userIndex = this.users.findIndex((u) => u._id === user._id)
        if (userIndex !== -1) {
          this.users.splice(userIndex, 1)
          this.listChatUsers()
        }
        for (let i = this.messages.length - 1; i >= 0; i--) {
          if (this.messages[i].user_id === user._id) {
            await this.removeMessage(i)
          }
        }
      } catch (error) {
        console.error('Error removing user from chat:', error)
      } finally {
        this.listChatUsers()
      }
    },

    append(emoji) {
      const messageInput = this.$refs.messageInput
      messageInput.innerText += emoji
      this.inputMessage = messageInput.innerText
    },

    async registerUser() {
      await this.loadPlanData()

      try {
        const users = await liveChat.getChatUsers(this.chat_id)
        this.users = users.users.filter(
          (user) =>
            user.is_valid !== false &&
            user.is_admin == true &&
            user.name_occurence == 1
        )

        const existingUser = this.users.find(
          (user) => user.user_name === this.userName
        )

        if (existingUser) {
          this.user_id = existingUser._id
          this.adminId = existingUser._id
        } else {
          const response = await liveChat.registerUserOnChat(
            this.userName,
            this.liveId
          )
          this.user_id = response.registered_user.user_id
        }
      } catch (error) {
        console.error('Error registering user:', error)
      }
    },

    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },

    adjustHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea.$el.querySelector('textarea')
        if (textarea) {
          const newHeight = textarea.scrollHeight
          this.textareaHeight = `${newHeight}px`
        }
      })
    },

    async getLiveInfo() {
      const response = await liveService.getLive(this.$route.params.id)
      this.chat_id = response.data.chat_id
      this.chatStatus = response.data.chat_status
      this.livePlayer = response.data.live_player

      await this.loadPlanData()
      if (this.chat_id !== null) {
        const users = await liveChat.getChatUsers(this.chat_id)
        this.users = users.users.filter(
          (user) =>
            user.is_valid !== false &&
            user.is_admin == true &&
            user.name_occurence == 1
        )

        const existingUser = this.users.find(
          (user) => user.user_name === this.userName
        )
        if (existingUser && this.chatStatus === 'active') {
          this.user_id = existingUser._id
        }
      }
    },
    selectOption(option) {
      this.form.selectedOption = option
    },
    sendMessage(event) {
      if (event) {
        event.preventDefault()
      }
      if (this.inputMessage.trim() !== '') {
        const sentAt = new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })
        const tempId = Date.now()
        this.socket.emit('send_message', {
          chat_id: this.chat_id,
          user_id: this.user_id,
          message: this.inputMessage,
          user_name: this.userName,
          isSentByUser: true,
          typedMessage: true,
          tempId: tempId,
          sent_at: sentAt,
          isAdmin: this.isAdmin,
        })

        this.messages.push({
          user_name: this.$t('message.pages.live.chat.you'),
          text: this.inputMessage,
          isSentByUser: true,
          typedMessage: true,
          message_id: tempId,
          user_id: this.user_id,
          tempId: tempId,
          sent_at: sentAt,
          isAdmin: this.isAdmin,
        })

        this.scrollToBottom()
        const messageInput = this.$refs.messageInput
        messageInput.innerText = ''
        this.inputMessage = ''
      }
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.waiting-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.modal {
  width: 510px;
  height: 304px;
  position: absolute;
  z-index: 9999;
  background-color: white;
  box-shadow: 0px 2px 20px 0px #00000026;
  border-radius: 8px;
  padding: 20px;
  left: -135px;
  transform: translateX(-50%);
  top: 27px;
  margin-top: 10px;

  button {
    background-color: white;
    padding: 0;
  }
}

.embedInput {
  padding: 0 0 0 0 !important;
}

.wrapText {
  word-break: break-word;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.placeholder {
  position: absolute;
  pointer-events: none;
  color: #c2c6e7;
  padding-left: 8px;
  line-height: 25px;
  user-select: none;
}

.editable-content:focus .placeholder {
  display: none;
}

.page_title {
  font-weight: 500;
  font-size: 18px;
  line-height: 21.6px;
  color: #0f21a1;
}

.modal_title {
  font-weight: 500;
  font-size: 18px;
  line-height: 21.6px;
  color: var(--v-neutral-base);
}

.label_title {
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: var(--v-neutral-lighten1);
}

.users-name {
  display: block;

  font: {
    family: Rubik;
    size: 18px;
    weight: 500;
  }

  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--v-primary-base);
}

.blocked-users {
  display: block;

  font: {
    family: Rubik;
    size: 18px;
    weight: 500;
  }

  line-height: 22px;
  letter-spacing: 0em;
}

.v-btn {
  letter-spacing: 0;
  text-transform: none;
}

.icons-container {
  display: flex;
  gap: 8px;
  padding: 8px 12px 8px 0px;
  align-items: flex-end;
}

.userInitials {
  margin-top: 6px;
  margin-left: 10px;
  font-size: 18px;
  background-color: #ebedff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  margin-right: 20px;
}

.chat-container {
  overflow-x: auto;
  overflow: hidden;
}

.chat-content {
  border-radius: 4px;
  border: 1px solid var(--neutral-lighter, #c2c6e7);
  background: var(--neutral-white, #fff);
  justify-content: space-between;
}

.chat-content:focus-within {
  border-color: var(--v-brand-base);
}

.mdi-content-copy::before {
  content: '\F018F';
  position: absolute;
  top: -38px;
}

.admin-name {
  color: red;
}

.message.sent-by-user {
  color: var(--v-primary-base);
  justify-content: left;
}

.v-application--is-ltr
  .v-textarea.v-text-field--enclosed
  .v-text-field__slot
  textarea {
  padding: 0 0 0 0 !important;
}

.user-quantity {
  margin-bottom: $spacing-base;

  display: block;

  font: {
    family: Rubik;
    size: 14px;
    weight: 500;
  }

  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--v-brand-darken1);
}

.editable-content:focus {
  outline: none; /* Remove the black outline */
}

.new-live-chat {
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 2;
  font-size: 1rem;
  color: var(--v-neutral-lighten1);

  .options {
    padding-top: 10px;
    text-align: center;
    border-bottom: 1px solid var(--v-neutral-lighten3);

    span {
      cursor: pointer;
      margin-right: 20px;
      transition: color 0.3s ease;
      padding-bottom: 11px;

      &.selected {
        color: var(--v-brand-base);
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }

  &::v-deep {
    @import '@/assets/scss/src/new-live';
  }
}

.v-icon.v-icon::after {
  background-color: transparent;
}

.chatOptions_selector {
  width: 50%;
  margin-bottom: -1px;
  padding-bottom: 11px;
  &.selected {
    border-bottom: 2px solid var(--v-brand-base);
  }
}

.inverted-border {
  width: 200px;
  height: 200px;
  background-color: #f0f0f0; /* Cor de fundo do quadrado */
  border-radius: 16px; /* Raio da borda arredondada */
  box-shadow: 0 0 0 10px #fff; /* Sombra externa que cria o efeito de borda invertida */
}

.user-item:hover {
  background-color: #e8eafd;

  .userInitials {
    background-color: #f8f8ff;
  }

  .dots-icon {
    opacity: 1;
  }
}

.send-icon:hover {
  cursor: pointer;
}

.waiting-message {
  font-size: 18px;
  font-weight: 400;
  line-height: 21.6px;
  color: #c2c6e7;
}

.chat {
  &__content {
    position: relative;
  }
}

.bg-dark {
  .modal_title {
    font-weight: 500;
    font-size: 18px;
    line-height: 21.6px;
    color: var(--v-neutral-lighten1);
  }

  .modal button {
    background-color: #171924;
  }

  .options {
    border-bottom: 1px solid #72727272;
  }

  .new-live-chat {
    background-color: var(--v-neutral-darken2);
    color: white;
  }
  .modal {
    background-color: var(--v-neutral-darken2);
  }
  .userInitials {
    background-color: var(--v-primary-base);
  }

  .user-item:hover {
    background-color: var(--v-primary-base);

    .userInitials {
      background-color: var(--v-primary-base);
    }

    .dots-icon {
      opacity: 1;
    }
  }

  .options {
    span {
      cursor: pointer;
      margin-right: 20px;
      transition: color 0.3s ease;
      padding-bottom: 11px;

      &.selected {
        color: var(--v-primary-base);
        font-weight: 500;
        margin-bottom: 10px;
      }
    }
  }

  .chatOptions_selector {
    width: 50%;
    padding-bottom: 11px;
    &.selected {
      border-bottom: 2px solid var(--v-primary-base);
    }
  }

  .page_title {
    color: var(--v-primary-base) !important;
  }

  .label_title {
    color: var(--v-primary-base) !important;
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}

.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  top: -322%;
  left: 37%;
  z-index: 1;
  border: 1px solid #ccc;
  width: 20rem;
  height: 20rem;
  overflow: scroll;
  overflow-x: hidden;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}

.exceededCount {
  display: flex;
  height: 20px;
  padding: 0px 4px 0px 3px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 2px;
  background: var(--neutral-dark, #232536);
}

.exceededCount span {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
  padding-bottom: 6px;
}

.editable-content {
  width: 440px;
}

@media (max-width: 1660px) {
  .editable-content {
    width: 322px;
  }
  .emoji-picker__search > input {
    width: 100px;
  }

  .emoji-picker {
    top: -289%;
    left: 38%;
    width: 15rem;
    height: 18rem;
  }
  .modal {
    width: 400px;
    left: -80px;
  }
  .size-fields {
    margin-bottom: 20px;
  }
}

@media (max-width: 1350px) {
  .editable-content {
    width: 222px;
  }
  .emoji-picker__search > input {
    width: 100px;
  }

  .emoji-picker {
    left: 15%;
    top: -193%;
    height: 12rem;
  }
  .modal {
    width: 310px;
    left: -26px;
  }

  .select-size {
    margin-bottom: 20px;
    font-size: 12px;
  }
}

.emoji-picker__search {
  display: flex;
}

.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}

.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-family: Rubik, sans-serif;
  cursor: default;
}

.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.emoji-picker .emojis:after {
  content: '';
  flex: auto;
}

.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}

.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

.bg-dark {
  .chat-content {
    background: var(--neutral-dark, #232536);
  }
}
</style>

<style>
.text-message textarea {
  overflow: hidden !important;
  padding-right: 65px !important;
}

.over-texting {
  color: #c2c6e7;
}
</style>
